// @flow
import {createActions} from 'redux-actions';

export const {
    header: {toggleMenu, toggleSearch},
} = createActions({
    HEADER: {
        /**
         * Toggle menu action payload creator.
         */
        TOGGLE_MENU: () => {},

        /**
         * Toggle search action payload creator.
         */
        TOGGLE_SEARCH: () => {},
    },
});
